import { render, staticRenderFns } from "./TutorialRoles.vue?vue&type=template&id=0338f951"
import script from "./TutorialRoles.vue?vue&type=script&lang=ts"
export * from "./TutorialRoles.vue?vue&type=script&lang=ts"
import style0 from "./TutorialRoles.vue?vue&type=style&index=0&id=0338f951&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports